import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from '@stockcare-services/authentication/authentication.service';
import { NotificationService } from '@stockcare-services/notification-service/notification.service';

@Injectable({
    providedIn: 'root'
})
export class AuthorisationAuthGuardService  {
    constructor(
        private authService: AuthenticationService,
        private notify: NotificationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const isInRole = this.authService.isInRole(route.data['roles']);

        if (!isInRole) {
            this.notify.error('Please make sure you have the correct roles assigned');
        }

        return isInRole;
    }
}
